import { Tooltip } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  // add event listener to tooltip to close it when ESC key is pressed
  document.addEventListener('keydown', (e) => {
    if (e.code === 'Escape') {
      document
        .querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach((el) => Tooltip.getInstance(el)?.hide());
    }
  });
});
